// @ts-nocheck
/**
 * /unsubscribe?token=… — one click, no login, no form.
 * A bad token reads exactly like a good one: the wording never names the
 * event, so nothing here tells anyone whether their token was real.
 */
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { invokeEdgeFunction } from '@/lib/invokeEdgeFunction';

const PublicUnsubscribePage: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    let cancelled = false;
    (async () => {
      await invokeEdgeFunction('rle-unsubscribe-notifications', {
        body: { token },
      });
      if (cancelled) return;
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center">
      {loading ? (
        <Loader2 className="mx-auto h-6 w-6 animate-spin text-muted-foreground" />
      ) : (
        <>
          <h1 className="text-2xl font-bold text-foreground">You're unsubscribed</h1>
          <p className="mt-3 text-muted-foreground">
            You won't get any more updates about this event.
          </p>
        </>
      )}
    </div>
  );
};

export default PublicUnsubscribePage;
